import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";

import { BIDService } from "src/app/services/common/bid.service";
import { RoomService } from "src/app/services/http/business/room/room.service";
import { MatDialog, MatPaginator, MatTableDataSource } from "@angular/material";
import { RoomEntryComponent } from "../room-entry/room-entry.component";
import { ICourseType } from "src/app/interfaces/course-type";
import { IRoom } from "src/app/interfaces/room";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { ErrorsService } from "src/app/services/common/errors.service";

@Component({
  selector: "app-room-list",
  templateUrl: "./room-list.component.html",
  styleUrls: ["./room-list.component.css"]
})
export class RoomListComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource<ICourseType>();
  displayedColumns: string[] = [
    this.translate.get("label.priority"),
    'name',
    this.translate.get("label.floor"),
    this.translate.get("label.capacity"),
    this.translate.get("label.virtualRoom"),
    this.translate.get("label.roomType"),
    "function"
  ];

  pageSize: number;
  pageIndex: number;

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private bidService: BIDService,
    private roomService: RoomService,
    private translate: TranslateService,
    private errorService: ErrorsService
  ) {}

  ngOnInit() {
    this.setBid();
    this.getRoomList();
  }

  setBid() {
    this.route.params.subscribe(res => {
      this.bidService.setBID(res.Bid);
    });
  }

  getRoomList() {
    this.roomService.list().subscribe(res => {
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  paginatorEvent(event) {
    this.roomService
      .list(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  add() {
    this.dialog
      .open(RoomEntryComponent)
      .afterClosed()
      .subscribe(() => {
        this.roomService.list().subscribe(re => {
          this.paginator.pageIndex = 0;
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
        });
      });
  }

  edit(e: IRoom) {
    this.dialog
      .open(RoomEntryComponent, {
        data: e
      })
      .afterClosed()
      .subscribe(() => {
        this.roomService.list(this.pageIndex, this.pageSize).subscribe(re => {
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
        });
      });
  }

  delete(data: IRoom): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.room") + " " + data.Title
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var xdata = {
          Id: data.Id
        };
        this.roomService.delete(xdata).subscribe(
          () => {
            this.roomService
              .list(this.pageIndex, this.pageSize)
              .subscribe(re => {
                this.dataSource = re.DataList;
                this.paginator.length = re.Total;
              });
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.bidService.setBID("");
  }
}
